import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CalculatorPage from "@/CalculatorPage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CalculatorPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
